import { createSlice } from '@reduxjs/toolkit';
import { FULLFILLED, PENDING, REJECTED } from '@constants/index';
import { FETCH_NOTIFICATION, FETCH_SUGGESTED_QUESTION } from '@root/store/action-types';

const INITIAL_STATE: IAppFeature = {
  data: {
    baseUrl: process.env.REACT_APP_BASE_URL || '',
    isSidebarVisible: false,
    isContactVisible: false,
    notificationVisibility: false,
  },
  validationStates: {
    suggestedQuestions: {
      isLoading: false,
      error: null,
    },
  },
};

export const appFeatureSlice = createSlice({
  name: 'app',
  initialState: INITIAL_STATE,
  reducers: {
    resetAppFeaturesData: (state) => {
      state.data =  INITIAL_STATE.data;
      state.validationStates = INITIAL_STATE.validationStates;
    },
    setIsSidebarVisible: (state, action) => {
      state.data.isSidebarVisible = action.payload;
    },
    setIsContactVisible: (state, action) => {
      state.data.isContactVisible = action.payload;
    },
    updateVisibility: (state, action) => {
      state.data.notificationVisibility = action.payload;
    },
  },

  extraReducers: (builder) => {
    builder.addCase(`${FETCH_SUGGESTED_QUESTION}${PENDING}`, (state) => {
      state.validationStates.suggestedQuestions.isLoading = true;
    });

    builder.addCase(`${FETCH_SUGGESTED_QUESTION}${FULLFILLED}`, (state) => {
      state.validationStates.suggestedQuestions.isLoading = false;
    });

    builder.addCase(`${FETCH_SUGGESTED_QUESTION}${REJECTED}`, (state) => {
      state.validationStates.suggestedQuestions.isLoading = false;
    });

    builder.addCase(`${FETCH_NOTIFICATION}${FULLFILLED}`, (state, action: any) => {
      state.data.notificationVisibility = action.payload?.length ? true : false;
    });
  },
});

export const {
  resetAppFeaturesData,
  setIsSidebarVisible,
  setIsContactVisible,
  updateVisibility,
} = appFeatureSlice.actions;
export const appFeatureReducer = appFeatureSlice.reducer;
